import PropTypes from 'prop-types';

import IconComponent from 'Component/Icon';
/** @namespace Bodypwa/Component/RulerIcon/Component */
export class RulerIconComponent extends IconComponent {
    static propTypes = {
        size: PropTypes.string.isRequired,
        color: PropTypes.string.isRequired,
        className: PropTypes.string
    };

    static defaultProps = {
        isRotated: false
    };

    render() {
        const { dimensions, colors } = this;
        const { size, color, className } = this.props;

        return (
          <svg
              className={ className }
              width={ dimensions[ size ] }
              height={ dimensions[ size ] }
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
          <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.2123 8.67651L10.5859 7.05016L8.81815
            8.81793L8.11105 8.11082L9.87881 6.34306L8.4646 4.92884L4.92907 8.46438L15.5357 19.071L19.0712
            15.5354L17.5863 14.0505L15.8185 15.8183L15.1114 15.1112L16.8792 13.3434L15.2528 11.7171L13.4851
            13.4848L12.778 12.7777L14.5457 11.01L12.9194 9.38362L11.1516 11.1514L10.4445 10.4443L12.2123
            8.67651ZM18.6469 11.5757L19.3541 12.2828L22.6067 15.5354L15.5357 22.6065L1.39353 8.46438L8.4646
            1.39331L11.6466 4.57529L12.3537 5.2824L13.98 6.90875L14.6871 7.61585L16.3135 9.2422L17.0206
            9.94931L18.6469 11.5757Z"
              fill={ colors[ color ] }
              className={ `icon-color ${className}` }
          />
          </svg>

        );
    }
}

export default RulerIconComponent;
